module.exports = __webpack_public_path__ + "img/team-03.aa762547.jpg";